@if (!spinnerType) {
  <div class="dialog-head" mat-dialog-title>
    <h2>{{type}}</h2>
    <button class="close-btn" mat-icon-button tabindex="-1" mat-dialog-close>
      <mat-icon>close</mat-icon>
    </button>
  </div>
}

@if (spinnerType) {
  <mat-dialog-content class="content" style="height: 180px;">
    <mat-spinner [diameter]="70" [strokeWidth]="3" style="margin: 20px auto;"></mat-spinner>
    <h2 style="text-align: center" i18n="Dialog common|label @@dialogCommon.loading">Идет загрузка...</h2>
  </mat-dialog-content>
}

@if (!spinnerType) {
  <mat-dialog-content class="content">
    <p class="mat-subtitle-1 message">{{data.message}}</p>
    @if (showCheckBox) {
      <p class="remove-with-telegram">
        <mat-checkbox color="warn" (change)="removeWithTelegram()" i18n="Dialog common|label @@dialogCommon.deleteTelegram">
      Удалить пост из канала в Telegram?
    </mat-checkbox>
      </p>
    }
  </mat-dialog-content>
}

@if (!spinnerType) {
  <mat-dialog-actions align="end">
    @if (confirmType || promptType) {
      <button id="dg_acs_cl_btn" mat-button mat-dialog-close color="secondary"
        i18n="Dialog common|button @@dialogCommon.cancelButton">ОТМЕНА
  </button>
    }
    <button id="dg_acs_ac_btn" mat-raised-button [color]="colorBtn" (click)="access()">
      {{button.name.toUpperCase()}}
    </button>
  </mat-dialog-actions>
}
